import ArrowLoopDoodle from '@monofront/design-system/visuals/Illustrations/ArrowLoopDoodle';
import StickerBackground from '@monofront/design-system/visuals/Backgrounds/StickerBackground';
import ResponsiveImage from '@monofront/design-system/components/ResponsiveImage';
import { IPrismicImage } from '@monofront/types';

import type { JSX } from "react";

interface IStickerWithImageProps {
  highlightedText: string;
  caption: string;
  image: IPrismicImage;
  legend?: JSX.Element;
  orientation?: 'left' | 'right';
}

export const StickerWithImage: React.FC<IStickerWithImageProps> = ({
  highlightedText,
  caption,
  image,
  legend,
  orientation = 'left',
}) => {
  return (
    <>
      <div className="sticker-with-image tw-relative tw-z-0 tw-mx-1 tw-mb-[86px] tw-flex tw-h-[153px] tw-w-[422px] tw-items-center tw-justify-center">
        <StickerBackground
          variant="E"
          UNSAFE_className="bubble-background desktop-only tw-absolute tw-left-0 tw-top-0 tw--z-[1]"
        />
        <StickerBackground
          variant="F"
          UNSAFE_className="bubble-background mobile-only tw-absolute tw-left-0 tw-top-0 tw--z-[1]"
        />

        {image.url && (
          <div className="sticker-img tw-shrink-0 tw-px-3">
            <ResponsiveImage
              src={image.url}
              alt={image.alt}
              width={image.dimensions?.width}
              height={image.dimensions?.height}
            />
          </div>
        )}

        <p className="sticker-content tw-px-3 tw-pb-4 tw-text-lg tw-font-semibold tw-leading-normal">
          <strong className="tw--mb-3 tw-block tw-font-title tw-text-[45px]">
            {highlightedText}
          </strong>
          <span className="tw-block tw-max-w-[190px] md:tw-max-w-[213px]">
            {caption}
          </span>
        </p>

        {legend && (
          <div
            className={`
            sticker-legend tw-absolute tw-top-[138px] tw-max-w-[250px] tw-font-light tw-italic
            ${
              orientation === 'left'
                ? 'tw-left-[13px]'
                : 'tw-right-[13px] tw-text-right'
            }
          `}
          >
            <ArrowLoopDoodle
              flipVertically={orientation === 'left'}
              rotate={40}
              UNSAFE_className={orientation === 'left' ? 'tw-ml-5' : 'tw-mr-6'}
              aria-hidden="true"
            />
            {legend}
          </div>
        )}
      </div>
      <style jsx>{`
        .sticker-legend :global(svg + *) {
          margin-top: var(--space-3);
        }

        @media (max-width: 800px) {
          .sticker-with-image {
            width: 327px;
          }
          .sticker-with-image:not(:last-child) {
            margin-bottom: 110px;
          }

          .sticker-content {
            font-size: var(--font-size-2);
          }

          .sticker-content strong {
            max-width: 190px;
            font-size: var(--font-size-5);
          }

          .sticker-legend :global(*) {
            font-size: var(--font-size-1-5);
          }
        }
      `}</style>
    </>
  );
};
